import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const supportViewFolderSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  viewIds: z.array(zExt.objectId()),
  defaultViews: z.array(z.string()),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
});

export type FolderSchema = z.infer<typeof supportViewFolderSchema>;
